import React from "react";
import { X, Video } from "lucide-react";

/**
 * Modal component for video call UI
 */
export const Modal = ({ isOpen, onClose, title, children, size = "md" }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    full: "max-w-full",
  };

  return (
    <div className="animate-fade-in fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div
        className={`${sizeClasses[size]} animate-scale-in w-full overflow-hidden rounded-xl bg-white shadow-2xl`}
      >
        <div className="flex items-center justify-between border-b border-gray-200 p-4">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <button
            onClick={onClose}
            className="rounded-full p-1 text-gray-500 transition duration-200 hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

/**
 * Loading spinner component for video call
 */
export const LoadingSpinner = ({ message, icon: Icon = Video }) => (
  <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-900">
    <div className="flex max-w-md animate-pulse flex-col items-center text-center">
      <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gray-800">
        <Icon size={40} className="text-blue-400" />
      </div>
      <h2 className="mb-2 text-2xl font-medium text-white">
        {message || "Joining call..."}
      </h2>
      <p className="mb-8 text-gray-400">Setting up your video and audio</p>
      <div className="h-2 w-64 overflow-hidden rounded-full bg-gray-800">
        <div className="animate-progress-bar h-full bg-blue-500"></div>
      </div>
    </div>
  </div>
);

